import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import ComplaintTable from "../../components/Complaint"

const Complaints = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Complaints | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <ComplaintTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Complaints
